import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  newFunctionGetList: params => axios({ baseURL, url: '/api/message/stationLetterSendsList', method: 'get', params }), // 前台-用户获取站内信接收列表
  newFunctionUpdateStatus: data => axios({ baseURL, url: '/api/message/stationLetterSends', method: 'put', data }), // 前台-更新站内信收件状态

  productTakeDownSendsList: params => axios({ baseURL, url: '/api/message/productTakeDownSendsList', method: 'get', params }), // 前台-用户获取产品下架接收列表
  getFileTaskList: data => axios({ url: '/api/product/getFileTaskList', method: 'POST', data }), // 前台通知tab页心愿清单导出--列表
  productTakeDownSends: data => axios({ baseURL, url: '/api/message/productTakeDownSends', method: 'put', data }), // 前台-更新产品下架通知收件状态
  stationLetterNewState: params => axios({ baseURL, url: '/api/message/stationLetterNewState', method: 'get', params }) // 用户获取站内信最新消息通知
}
